// /pages/MaintenanceHistory/index.tsx
// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { 
//     Box, Heading, Text, HStack, VStack, InputGroup, Input, 
//     InputRightElement, IconButton, Card, CardHeader, CardBody, 
//     Icon
// } from '@chakra-ui/react';
// import { Search, ChevronLeft } from 'lucide-react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { apiClient } from '@/lib/api/client';
// import { useToastNotification } from '@/lib/utils/useToastNotification';
// import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';
// import { useAccessCheck } from '@/hooks/useAccess';
// import { useThemeColors } from '@/hooks/useThemeColors';
// import { ActionButtons } from '@/components/common/ActionButtons';


// const MaintenanceHistoryPage: React.FC = () => {
//     const { id } = useParams<{ id: string }>();
//     const navigate = useNavigate();
//     const access = useAccessCheck();
//     const tableRef = useRef<DataTableRef>(null);
//     const searchRef = useRef<HTMLInputElement>(null);
//     const colors = useThemeColors();

//     const [truckPlate, setTruckPlate] = useState('');
//     const [searchQuery, setSearchQuery] = useState('');

//     useEffect(() => {
//         const fetchTruck = async () => {
//             try {
//                 const response = await apiClient.get(`/trucks/get-truck-by-id/${id}`);
//                 setTruckPlate(response.data.plate_number);
//             } catch (error) {
//                 console.error(error);
//             }
//         };
//         if (id) fetchTruck();
//     }, [id]);

//     // 🌟 1. Date Formatter: "December 18, 2025"
//     const renderFormattedDate = (value: string) => {
//         if (!value) return '-';
//         const date = new Date(value);
//         return date.toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric',
//         });
//     };

//     // 🌟 2. Total Cost Calculator (Fixes the blank column)
//     const renderTotalCost = (_: any, row: any) => {
//         const qty = Number(row.quantity) || 0;
//         const price = Number(row.price) || 0;
//         const total = qty * price;
//         return `P ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//     };

//     const tableOptions: DataTableOptions = useMemo(() => ({
//         dataFields: {
//             receipt_number: { name: 'Receipt', withSort: true, maxWidth: '150px' },
//             article: { name: 'Article', withSort: true },
//             quantity: { name: 'Qty', withSort: true, maxWidth: '80px' },
//             price: { name: 'Price', withSort: true, maxWidth: '120px' },
//             total: { name: 'Total Cost', withSort: false, maxWidth: '150px' }, // Uses custom renderer below
//             maintenance_date: { name: 'Date', withSort: true, maxWidth: '200px' },
//         },
//         actions: [
//             {
//                 label: 'Edit Record',
//                 action: 'Edit',
//                 icon: 'Edit',
//                 can_do: access.can_edit,
//             }
//         ],
//         dataSource: `/trucks/${id}/maintenance-history`, 
//         primaryKey: 'id',
//         //editPath: (recordId: any) => `/fleet-management/maintenance-history/${recordId}/edit`,
//         editPath: (recordId: any) => `/fleet-management/maintenance-history/${id}/${recordId}`,
//         softDelete: true,
//         displayInModal: true,
//         noRecordText: 'No maintenance records found',
//         showSelection: false,
//     }), [id, access.can_edit]);

//     // Update onOpenModal as well just in case
//     const handleEdit = (row: any) => {
//             // 1. Get the Maintenance Record ID
//             const recordId = typeof row === 'object' ? row.id : row;
            
//             // 2. 'id' comes from your useParams() at the top of the page (the Truck ID)
//             // We navigate to /truckId/recordId to match the /:id/:id permission
//             if (id && recordId) {
//                 navigate(`/fleet-management/maintenance-history/${id}/${recordId}`);
//             } else {
//                 console.error("Missing IDs for navigation:", { truckId: id, recordId });
//             }
//         };

//     const handleSearch = () => {
//         const query = searchRef.current?.value || '';
//         setSearchQuery(query); 
//         tableRef.current?.applyFilter('search', query); 
//     };

//     return (
//         <AdminLayout>
//             <Box p={4} h="100%" display="flex" flexDirection="column">
//                 <VStack spacing={4} align="stretch" flex="1" minH={0}>
//                     <Card display="flex" flexDirection="column" flex="1" minH={0} overflow="hidden">
                        
//                         {/* 🌟 Updated Header with Back Arrow */}
//                         <CardHeader py={3} px={6}>
//                             <HStack spacing={3} align="center">
//                                 <IconButton
//                                     aria-label="Go back"
//                                     icon={<Icon as={ChevronLeft} boxSize={6} />}
//                                     variant="ghost"
//                                     size="sm"
//                                     onClick={() => navigate('/fleet-management/trucks')} // 🌟 Adjust path as needed
//                                     _hover={{ bg: 'gray.100' }}
//                                 />
//                                 <Box>
//                                     <Heading size="md" fontWeight="bold">
//                                         Maintenance History: {truckPlate}
//                                     </Heading>
//                                     <Text fontSize="sm" color="gray.500">
//                                         History of parts and services for this vehicle.
//                                     </Text>
//                                 </Box>
//                             </HStack>
//                         </CardHeader>
                        
//                         {/* Search and Action Buttons Section */}
//                         <CardHeader py={0} px={6}>
//                             <HStack justify="space-between" align="center" width="100%" pb={4}>
//                                 <Box flex="0 1 auto" minW="250px" maxW="400px">
//                                     <InputGroup size="sm">
//                                         <Input
//                                             ref={searchRef}
//                                             placeholder="Search records..."
//                                             onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//                                             defaultValue={searchQuery}
//                                         />
//                                         <InputRightElement width="2.5rem">
//                                             <IconButton
//                                                 aria-label="Search"
//                                                 icon={<Search size={16} />}
//                                                 size="sm"
//                                                 variant="ghost"
//                                                 onClick={handleSearch}
//                                             />
//                                         </InputRightElement>
//                                     </InputGroup>
//                                 </Box>

//                                 <Box pb={2}>
//                                     <ActionButtons
//                                         pathname={`/fleet-management/maintenance-history/${id}`}
//                                         createLabel="Add Article"
//                                     />
//                                 </Box>
//                             </HStack>
//                         </CardHeader>
                        
//                         <CardBody p={0} mx={6} flex="1" display="flex" flexDirection="column" overflow="hidden" sx={{
//                                 'th:first-of-type, td:first-of-type': {
//                                     display: 'none',
//                                 }
//                             }}>
//                             <Box h="100%">
//                                 <DataTable
//                                     ref={tableRef}
//                                     options={tableOptions}
//                                     onOpenModal={handleEdit}
//                                     access={{ can_edit: access.can_edit, can_create: access.can_create, can_delete: access.can_delete }}
//                                     customRenderers={{
//                                         maintenance_date: renderFormattedDate,
//                                         total: renderTotalCost, 
//                                     }}
//                                 />
//                             </Box>
//                         </CardBody>
//                     </Card>
//                 </VStack> 
//             </Box> 
//         </AdminLayout>
//     );
// };

// export default MaintenanceHistoryPage;



// // /pages/MaintenanceHistory/index.tsx


//export default MaintenanceHistoryPage;

// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { 
//     Box, Heading, Text, HStack, VStack, InputGroup, Input, 
//     InputRightElement, IconButton, Card, CardHeader, CardBody, 
//     Icon
// } from '@chakra-ui/react';
// import { Search, ChevronLeft } from 'lucide-react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { apiClient } from '@/lib/api/client';
// import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';
// import { useAccessCheck } from '@/hooks/useAccess';
// import { useThemeColors } from '@/hooks/useThemeColors';
// import { ActionButtons } from '@/components/common/ActionButtons';

// const MaintenanceHistoryPage: React.FC = () => {
//     const { id } = useParams<{ id: string }>();
//     const navigate = useNavigate();
//     const access = useAccessCheck();
//     const tableRef = useRef<DataTableRef>(null);
//     const searchRef = useRef<HTMLInputElement>(null);
//     const colors = useThemeColors();

//     const [truckPlate, setTruckPlate] = useState('');
//     const [searchQuery, setSearchQuery] = useState('');

//     // Pattern: Reactive params for the DataTable
//     const tableParams = useMemo(() => ({ search: searchQuery }), [searchQuery]);

//     useEffect(() => {
//         const fetchTruck = async () => {
//             try {
//                 const response = await apiClient.get(`/trucks/get-truck-by-id/${id}`);
//                 setTruckPlate(response.data.plate_number);
//             } catch (error) {
//                 console.error(error);
//             }
//         };
//         if (id) fetchTruck();
//     }, [id]);

//     const handleSearch = () => {
//         const query = searchRef.current?.value || '';
//         setSearchQuery(query); 
//         tableRef.current?.applyFilter('search', query); 
//     };

//     const handleKeyDown = (e: React.KeyboardEvent) => {
//         if (e.key === 'Enter') handleSearch();
//     };

//     const tableOptions: DataTableOptions = useMemo(() => ({
//         dataSource: `/trucks/${id}/maintenance-history`, 
//         primaryKey: 'id',
//         showSelection: false,
//         showCheckboxes: false,
//         softDelete: true,
//         displayInModal: false, // Navigate to form page
//         noRecordText: 'No maintenance records found',
//         editPath: (recordId: any) => `/fleet-management/maintenance-history/${id}/${recordId}`,
        
//         dataFields: {
//             receipt_number: { name: 'Receipt', withSort: true, maxWidth: '150px' },
//             article: { name: 'Article', withSort: true },
//             quantity: { name: 'Qty', withSort: true, maxWidth: '80px' },
//             price: { name: 'Price', withSort: true, maxWidth: '120px' },
//             total: { name: 'Total Cost', withSort: false, maxWidth: '150px' },
//             maintenance_date: { name: 'Date', withSort: true, maxWidth: '200px' },
//         },
//         actions: [
//             {
//                 label: 'Edit Record',
//                 action: 'Edit',
//                 icon: 'Edit',
//                 can_do: access.can_edit,
//             }
//         ],
//     }), [id, access.can_edit]);

//     const customRenderers = useMemo(() => ({
//         maintenance_date: (value: string) => {
//             if (!value) return '-';
//             return new Date(value).toLocaleDateString('en-US', {
//                 year: 'numeric',
//                 month: 'long',
//                 day: 'numeric',
//             });
//         },
//         total: (_: any, row: any) => {
//             const qty = Number(row.quantity) || 0;
//             const price = Number(row.price) || 0;
//             const total = qty * price;
//             return `P ${total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//         },
//     }), []);

//     const permissions = useMemo(() => ({
//         can_edit: access.can_edit,
//         can_create: access.can_create,
//         can_delete: access.can_delete,
//         can_view: access.can_view,
//     }), [access]);

//     return (
//         <AdminLayout>
//             <Box p={4} h="100%" display="flex" flexDirection="column">
//                 <VStack spacing={2} align="stretch" flex="1" minH={0}>
//                     <Card flexShrink={0} display="flex" flexDirection="column" flex="1" minH={0} overflow="hidden">
                        
//                         <CardHeader py={3} px={5}>
//                             <HStack spacing={3} align="center">
//                                 <IconButton
//                                     aria-label="Go back"
//                                     icon={<Icon as={ChevronLeft} boxSize={6} />}
//                                     variant="ghost"
//                                     size="sm"
//                                     onClick={() => navigate('/fleet-management/trucks')}
//                                 />
//                                 <Box>
//                                     <Heading size="md" mb={1}>
//                                         Maintenance History: {truckPlate}
//                                     </Heading>
//                                     <Text fontSize="sm" color={colors.text}>
//                                         History of parts and services for this vehicle.
//                                     </Text>
//                                 </Box>
//                             </HStack>
//                         </CardHeader>
                        
//                         <CardHeader py={0} px={0} flexShrink={0}>
//                             <Box pt={2} pb={0}>
//                                 <HStack justify="space-between" align="flex-end" spacing={4} px={5} width="100%">
//                                     <Box flex="0 1 auto" minW="400px" maxW="400px">
//                                         <InputGroup size="sm">
//                                             <Input
//                                                 ref={searchRef}
//                                                 placeholder="Search records..."
//                                                 onKeyDown={handleKeyDown}
//                                                 defaultValue={searchQuery}
//                                                 pr="2.5rem"
//                                             />
//                                             <InputRightElement width="2.5rem">
//                                                 <IconButton
//                                                     aria-label="Search"
//                                                     icon={<Search size={16} />}
//                                                     size="sm"
//                                                     h="1.75rem"
//                                                     w="1.75rem"
//                                                     onClick={handleSearch}
//                                                     variant="ghost"
//                                                 />
//                                             </InputRightElement>
//                                         </InputGroup>
//                                     </Box>

//                                     <Box>
//                                         <ActionButtons
//                                             pathname={`/fleet-management/maintenance-history/${id}`}
//                                             createLabel="Add Article"
//                                         />
//                                     </Box>
//                                 </HStack>
//                                 <Box mx={4} height={4} />
//                             </Box>
//                         </CardHeader>
                        
//                         <CardBody
//                             p={0}
//                             pt={1}
//                             pb={4}
//                             mx={5}
//                             flex="1"
//                             overflow="hidden"
//                             display="flex"
//                             flexDirection="column"
//                             minH={0}
//                         >
//                             <Box h="100%" display="flex" flexDirection="column" minH={0}>
//                                 <DataTable
//                                     ref={tableRef}
//                                     options={tableOptions}
//                                     params={tableParams}
//                                     access={permissions}
//                                     customRenderers={customRenderers}
//                                     onOpenModal={(row) => {
//                                         const recordId = typeof row === 'object' ? row.id : row;
//                                         if (id && recordId) {
//                                             navigate(`/fleet-management/maintenance-history/${id}/${recordId}`);
//                                         }
//                                     }}
//                                 />
//                             </Box>
//                         </CardBody>
//                     </Card>
//                 </VStack> 
//             </Box> 
//         </AdminLayout>
//     );
// };

// export default MaintenanceHistoryPage;

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { 
    Box, Heading, Text, HStack, VStack, InputGroup, Input, 
    InputRightElement, IconButton, Card, CardHeader, CardBody, 
    Icon, Select
} from '@chakra-ui/react';
import { Search, ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { apiClient } from '@/lib/api/client';
import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';
import { useAccessCheck } from '@/hooks/useAccess';
import { useThemeColors } from '@/hooks/useThemeColors';
import { ActionButtons } from '@/components/common/ActionButtons';

const MaintenanceHistoryPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const access = useAccessCheck();
    const tableRef = useRef<DataTableRef>(null);
    const searchRef = useRef<HTMLInputElement>(null);
    const colors = useThemeColors();

    const [truckPlate, setTruckPlate] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    
    // --- 🌟 FILTER STATE ---
    const [filterType, setFilterType] = useState<'weekly' | 'monthly'>('weekly');
    const [currentDate, setCurrentDate] = useState(new Date());

    // --- 🌟 NAVIGATION LOGIC ---
    const adjustDate = (direction: number) => {
        const newDate = new Date(currentDate);
        if (filterType === 'weekly') {
            newDate.setDate(newDate.getDate() + (direction * 7));
        } else {
            newDate.setMonth(newDate.getMonth() + direction);
        }
        setCurrentDate(newDate);
    };

    const dateRangeDisplay = useMemo(() => {
        const start = new Date(currentDate);
        if (filterType === 'weekly') {
            const day = start.getDay();
            const diff = start.getDate() - day + (day === 0 ? -6 : 1); 
            start.setDate(diff);
            const end = new Date(start);
            end.setDate(start.getDate() + 6);
            return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
        }
        return start.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    }, [currentDate, filterType]);

    const permissions = useMemo(() => ({
        can_edit: false,
        can_create: access.can_create,
        can_delete: access.can_delete,
        can_view: access.can_view,
    }), [access]);

    const tableParams = useMemo(() => ({ 
        search: searchQuery,
        filter_type: filterType,
        reference_date: currentDate.toISOString().split('T')[0] 
    }), [searchQuery, filterType, currentDate]);

    useEffect(() => {
        const fetchTruck = async () => {
            try {
                const response = await apiClient.get(`/trucks/get-truck-by-id/${id}`);
                setTruckPlate(response.data.plate_number);
            } catch (error) { console.error(error); }
        };
        if (id) fetchTruck();
    }, [id]);

    const handleSearch = () => {
        setSearchQuery(searchRef.current?.value || '');
        tableRef.current?.applyFilter('search', searchRef.current?.value || '');
    };

    const handleEdit = (row: any) => {
        // Determine the record ID (some DataTables pass the whole row, some just the ID)
        const recordId = typeof row === 'object' ? row.id : row;
        
        // Ensure we have both the Truck ID (from params) and the Maintenance Record ID
        if (id && recordId) {
            navigate(`/fleet-management/maintenance-history/${id}/${recordId}`);
        } else {
            console.error("Missing IDs for navigation:", { truckId: id, recordId });
        }
    };

    const tableOptions: DataTableOptions = useMemo(() => ({
        dataSource: `/trucks/${id}/maintenance-history`, 
        primaryKey: 'id',
        showSelection: false,
        showCheckboxes: false,
        softDelete: false,
        displayInModal: true,
        showActionsColumn: false,
        noRecordText: 'No maintenance records found',
        editPath: (recordId: any) => `/fleet-management/maintenance-history/${id}/${recordId}`,
        dataFields: {
            receipt_number: { name: 'Receipt', withSort: true, maxWidth: '150px' },
            article: { name: 'Article', withSort: true },
            quantity: { name: 'Qty', withSort: true, maxWidth: '80px' },
            price: { name: 'Price', withSort: true, maxWidth: '120px' },
            total: { name: 'Total Cost', withSort: false, maxWidth: '150px' },
            maintenance_date: { name: 'Date', withSort: true, maxWidth: '200px' },
        },
        //actions: [{ label: 'Edit Record', action: 'Edit', icon: 'Edit', can_do: access.can_edit }],
        actions: [],
    }), [id]);

    const customRenderers = useMemo(() => ({
        maintenance_date: (value: string) => value ? new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '-',
        total: (_: any, row: any) => `P ${(Number(row.quantity) * Number(row.price)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    }), []);

    return (
        <AdminLayout>
            <Box p={4} h="100%" display="flex" flexDirection="column">
                <VStack spacing={2} align="stretch" flex="1" minH={0}>
                    <Card flexShrink={0} display="flex" flexDirection="column" flex="1" minH={0} overflow="hidden">
                        
                        <CardHeader py={3} px={5}>
                            <HStack spacing={3} align="center">
                                <IconButton aria-label="Back" icon={<Icon as={ChevronLeft} boxSize={6} />} variant="ghost" size="sm" onClick={() => navigate('/fleet-management/trucks')} />
                                <Box><Heading size="md" mb={1}>Maintenance History: {truckPlate}</Heading></Box>
                            </HStack>
                        </CardHeader>
                        
                        {/* 🌟 INTEGRATED FILTER BAR */}
                        <CardHeader py={0} px={5} flexShrink={0}>
                            <HStack justify="space-between" align="center" w="100%" pb={4}>
                                <HStack spacing={2}>
                                    <Select size="sm" w="120px" value={filterType} onChange={(e) => setFilterType(e.target.value as any)}>
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                    </Select>
                                    
                                    <HStack spacing={1}>
                                        <IconButton icon={<ChevronLeft size={18} />} aria-label="Prev" size="sm" variant="ghost" onClick={() => adjustDate(-1)} />
                                        
                                        <HStack 
                                            border="1px solid" borderColor="gray.200" px={3} py={1} borderRadius="md" bg="white" cursor="pointer"
                                            onClick={() => (document.getElementById('date-picker') as HTMLInputElement)?.showPicker()}
                                        >
                                            <Icon as={Calendar} size={14} color="gray.500" />
                                            <Text fontWeight="medium" fontSize="sm">{dateRangeDisplay}</Text>
                                            <input 
                                                id="date-picker" type="date" style={{ width: 0, height: 0, opacity: 0, position: 'absolute' }}
                                                onChange={(e) => e.target.value && setCurrentDate(new Date(e.target.value))}
                                            />
                                        </HStack>

                                        <IconButton icon={<ChevronRight size={18} />} aria-label="Next" size="sm" variant="ghost" onClick={() => adjustDate(1)} />
                                    </HStack>
                                </HStack>

                                {/* <ActionButtons pathname={`/fleet-management/maintenance-history/${id}`} createLabel="Add Article" /> */}
                            </HStack>
                         </CardHeader>

                         <CardHeader py={0} px={5} flexShrink={0}>
                             <Box maxW="400px" pb={4}>
                                 <InputGroup size="sm">
                                     <Input ref={searchRef} placeholder="Search records..." onKeyDown={(e) => e.key === 'Enter' && handleSearch()} />
                                     <InputRightElement><IconButton aria-label="Search" icon={<Search size={16} />} size="sm" variant="ghost" onClick={handleSearch} /></InputRightElement>
                                 </InputGroup>
                             </Box>
                         </CardHeader>
                       
                         <CardBody p={0} pt={1} pb={4} mx={5} flex="1" overflow="hidden" display="flex" flexDirection="column">
                             {/* <DataTable 
                                ref={tableRef} 
                                options={tableOptions} 
                                params={tableParams} 
                                access={permissions} 
                                customRenderers={customRenderers} 
                                onOpenModal={(row) => navigate(`/fleet-management/maintenance-history/${id}/${row.id || row}`)} /> */}
                                <DataTable 
                                    ref={tableRef} 
                                    options={tableOptions} 
                                    params={tableParams} 
                                    access={permissions} 
                                    customRenderers={customRenderers} 
                                    onOpenModal={handleEdit} 
                                />
                        </CardBody>
                    </Card>
                </VStack> 
            </Box> 
        </AdminLayout>
    );
};

export default MaintenanceHistoryPage;